import { faCalendar, faClock } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

import { BottomNavigation, ILinkData } from '../../../App/Components'
import { IUser } from '../../../User/DataStore/IUser'

type Props = {
  currentUser: IUser
}

export const BottomNavigationSetup: React.FC<Props> = ({ currentUser }) => {
  const bottomNavContent: ILinkData[] = [
    { path: '/profile', icon: faCalendar },
    { path: `/hr/working-hours/person/${currentUser.uuid}`, icon: faClock },
  ]

  return (
    <BottomNavigation
      key={`botNavigation`}
      links={bottomNavContent}
      addButton={'/profile/absence-request/add'}
    />
  )
}
